import { NavLink, Outlet } from "react-router-dom";
import Seo from "@/components/Seo";

const TABS = [
  { label: "Profile", to: "/app/settings/profile", testid: "settings-tab-profile" },
  { label: "Organization", to: "/app/settings/organization", testid: "settings-tab-organization" },
  { label: "Members", to: "/app/settings/members", testid: "settings-tab-members" },
  { label: "Preferences", to: "/app/settings/preferences", testid: "settings-tab-preferences" },
  { label: "Billing", to: "/app/settings/billing", testid: "settings-tab-billing" },
];

export default function SettingsLayout() {
  return (
    <div data-testid="settings-page">
      <Seo title="Settings" description="Manage your StUpEco Workspace account settings." path="/app/settings" />
      <div className="mb-8">
        <p className="eyebrow text-brand-teal">Settings</p>
        <h1 className="mt-2 font-display text-3xl font-semibold tracking-tight">Settings</h1>
        <p className="mt-2 text-sm text-muted-foreground">Manage your profile, organization and workspace preferences.</p>
      </div>

      <div className="flex flex-col gap-8 lg:flex-row">
        <nav className="flex gap-1 overflow-x-auto lg:w-56 lg:flex-col lg:overflow-visible">
          {TABS.map((t) => (
            <NavLink
              key={t.to}
              to={t.to}
              data-testid={t.testid}
              className={({ isActive }) =>
                `whitespace-nowrap rounded-xl px-4 py-2.5 text-sm font-medium transition-colors ${
                  isActive ? "bg-card text-foreground ring-1 ring-border" : "text-muted-foreground hover:text-foreground"
                }`
              }
            >
              {t.label}
            </NavLink>
          ))}
        </nav>
        <div className="min-w-0 flex-1">
          <Outlet />
        </div>
      </div>
    </div>
  );
}
